import React from "react";
import { Box } from "@material-ui/core";
import { CorporateReferralBanner } from "halifax";
import {
  SessionInfo,
  CorpSessionInfo,
  CorporateReferralBannerSource,
  Funnel,
  RewardsAccount,
} from "redmond";

interface CorpHomePageTopSectionProps {
  sessionInfo: SessionInfo | CorpSessionInfo;
  accounts?: RewardsAccount[];
  selectedAccountReferenceId?: string | null;
  funnel?: Funnel;
  trackEvent: (event: {
    eventName: string;
    properties: Record<string, unknown>;
  }) => void;
}

export const CorpHomePageTopSection = ({
  sessionInfo,
  accounts,
  selectedAccountReferenceId,
  funnel,
  trackEvent,
}: CorpHomePageTopSectionProps) => (
  <Box>
    <CorporateReferralBanner
      sessionInfo={sessionInfo}
      source={CorporateReferralBannerSource.Homepage}
      trackEvent={trackEvent}
      funnel={funnel}
      accounts={accounts}
      activeUserBusinessId={selectedAccountReferenceId}
    />
  </Box>
);
